import React, { useState, useEffect } from 'react';
    import { Outlet, useLocation } from 'react-router-dom';
    import { useAuth } from '../contexts/AuthContext';
    import Navbar from './Navbar';
    import MobileNavbar from './MobileNavbar';
    import Sidebar from './Sidebar';
    import NotificationCenter from './NotificationCenter';

    const Layout = () => {
      const { user, loading } = useAuth();
      const location = useLocation();
      const [showSidebar, setShowSidebar] = useState(false);
      const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

      // Handle window resize for responsive layout
      useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

      // Close sidebar when route changes
      useEffect(() => {
        setShowSidebar(false);
      }, [location]);

      // Show loading spinner while auth is initializing
      if (loading) {
        return (
          <div className="flex items-center justify-center h-screen bg-gray-50 dark:bg-neutral-900">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
              <p className="text-gray-600 dark:text-gray-400">Loading ILM Global...</p>
            </div>
          </div>
        );
      }

      // Always render the layout - don't redirect here
      return (
        <div className="mobile-app-container relative">
          {/* Top Navigation */}
          <Navbar />

          {/* Main Content - Updated padding to account for fixed navbars */}
          <main className="mobile-app-content pt-16 pb-20">
            <Outlet />
          </main>

          {/* Mobile Navigation */}
          <MobileNavbar />

          {/* Desktop Sidebar - Hidden on mobile */}
          {!isMobile && <Sidebar />}

          {/* Notifications */}
          <NotificationCenter />
        </div>
      );
    };

    export default Layout;